import type { AuthResponse } from '@/types/user';

import { apiClient, apiRequest } from '../api/client';
import type { ApiResult } from '../api/types';

export type ProfileData = {
  firstName: string;
  lastName: string;
  phone: string;
  position: string;
  email: string;
  username: string;
};

export type UpdateProfileData = {
  firstName?: string;
  lastName?: string;
  phone?: string;
  position?: string;
  username?: string;
};

export type AdvisorPublicInfo = {
  username: string;
  firstName: string;
  lastName: string;
  phone: string;
  position: string;
};

export async function getProfile(): Promise<ApiResult<ProfileData>> {
  return apiRequest(() => apiClient.get<ProfileData>('/auth/profile'));
}

export async function updateProfile(
  data: UpdateProfileData
): Promise<ApiResult<AuthResponse>> {
  return apiRequest(() => apiClient.put<AuthResponse>('/auth/profile', data));
}

export async function getAdvisorPublicInfo(
  advisorId: string
): Promise<ApiResult<AdvisorPublicInfo>> {
  return apiRequest(() =>
    apiClient.get<AdvisorPublicInfo>(`/auth/advisor/${advisorId}`)
  );
}
